
import { defineComponent, PropType } from 'vue'
import * as algosdk from 'algosdk'
import { Account, Dapp } from '@/types';
import api from '@/api/dapps';

export default defineComponent({
    name: 'BetModal',

    props: {
        teamName: {
            type: String,
            required: true,
        },
        teamColor: String,
        dapp: {
            type: Object as PropType<Dapp>,
            required: true
        },
    },
    data() {
        return {
            amount: 0,
            isValidAddress: true,
            confirmText: "",
        }
    },
    computed: {
        accounts(): Account[] {
            return this.$store.state.userAccounts;
        }
    },
    methods: {     
        async onSubmit(e: Event) {
            e.preventDefault();

            if (!this.amount) {
                alert('Please specify an amount')
                return
            }

            let elem: HTMLSelectElement = document.getElementById("account") as HTMLSelectElement;
            let acc = elem.value;

            if (!algosdk.isValidAddress(acc)) {
                this.isValidAddress = false
                return
            } else {
                this.isValidAddress = true
            }

            console.log("Betting " + this.amount + " on " + this.teamName 
            + " with account " + acc);
        
            // construct the transaction and sign
            api.optInToDapp(acc, this.dapp, algosdk.algosToMicroalgos(this.amount), this.teamName as string).then( () => {
                this.confirmText = "Transaction Complete!";
            }).catch((e) => {
                console.error(e);
                this.confirmText = "Transaction Failed!";
            });
        }
    },
    emits: ['toggle-bet-modal']
})
